"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
var _permission = require("@/utils/permission");
var _validate = require("@/utils/validate");
var _public = require("@/libs/public");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'UserGroup',
  data: function data() {
    return {
      tableFrom: {
        page: 1,
        limit: 20
      },
      tableData: {
        data: [],
        total: 0
      },
      listLoading: true,
      labelPram: {
        id: null,
        name: null,
        dialogConfig: {
          visible: false
        }
      },
      rules: {
        name: [{
          required: true,
          message: '请输入用户标签',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:user:tag:list'])) this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    openAdd: function openAdd(row) {
      row ? this.labelPram.id = row.id : this.labelPram.id = null;
      row ? this.labelPram.name = row.name : this.labelPram.name = null;
      this.labelPram.dialogConfig.visible = true;
    },
    onAdd: (0, _validate.Debounce)(function (formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.labelPram.id ? (0, _user.tagUpdateApi)({
            id: _this.labelPram.id,
            name: _this.labelPram.name
          }).then(function () {
            _this.$message.success('编辑成功');
            _this.labelPram.dialogConfig.visible = false;
            _this.getList();
          }) : (0, _user.tagSaveApi)({
            name: _this.labelPram.name
          }).then(function () {
            _this.$message.success('新增成功');
            _this.labelPram.dialogConfig.visible = false;
            _this.getList();
          });
        } else {
          return false;
        }
      });
    }),
    // 列表
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _user.tagListApi)(this.tableFrom).then(function (res) {
        _this2.tableData.data = res.list;
        _this2.tableData.total = res.total;
        _this2.listLoading = false;
      }).catch(function (res) {
        _this2.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    // 删除
    handleDelete: function handleDelete(id, idx) {
      var _this3 = this;
      this.$modalSure('删除吗？所有用户已经关联的数据都会清除').then(function () {
        (0, _user.tagDeleteApi)(id).then(function () {
          _this3.$message.success('删除成功');
          (0, _public.handleDeleteTable)(_this3.tableData.data.length, _this3.tableFrom);
          _this3.getList();
        });
      });
    },
    resetForm: function resetForm(formName) {
      this.labelPram.dialogConfig.visible = false;
      this.$refs[formName].resetFields();
      this.$emit('resetForm');
    }
  }
};